import config from "./config";

export default {
  baseUrl: `${config.serverUrl}`,

  /**Login Route */
  login: "/auth/dashboard/login",

  /**Login Userdata */
  getLoggedInUserData: "",

  /**Forgot Password  Route */
  forgotPassword: "/auth/dashboard/forgot-password",

  /**Change Password  Route */
  changePassword: "/auth/dashboard/change-password",

  /** generateNewToken */
  generateNewToken: "/auth/dashboard/generate-token",

  /**Reset Password  Route */
  setNewPassword: "/auth/dashboard/reset-password",

  /**Varify Password  Route */
  varifyOTP: "/auth/dashboard/verify-otp",

  /**encrypt Route */
  encrypt: "/auth/dashboard/encrypt",

  /**Country */
  fetchCountry: "/core/city-states/locations",

  /** fetchDealerState */
  fetchDealerState: "/core/city-states/get-state",

  /**fetchDealerCity */
  fetchDealerCity: "/core/city-states/get-city",

  /** fetchState */
  fetchState: "/core/city-states/locations",

  /** fetchBranchFilterState */
  fetchBranchFilterState: "/riders/dashboard/branches/states",

  /**fetchRideState */
  fetchRideState: "/core/city-states/locations",

  /**fetchRideCity */
  fetchRideCity: "/core/city-states/locations",

  /** fetchBranchFilterCity */
  fetchBranchFilterCity: "/riders/dashboard/branches/cities",

  /** fetchCity */
  fetchCity: "/core/city-states/locations",

  /**Fetch All Dealer */
  fetchAllDealer: "/riders/dashboard/dealer",

  /**Fetch Single Dealer */
  fetchSingleDealer: "/riders/dashboard/dealer/detail",

  /** Fetch Dealer Branch */
  fetchDealerBranch: "/riders/dashboard/branches",

  /**Country */
  fetchCountryBranch: "/core/city-states/locations",

  /**State */
  fetchStateBranch: "/core/city-states/locations",

  /**City */
  fetchCityBranch: "/core/city-states/locations",

  /**Create Branch */
  createBranch: "/riders/dashboard/branches",

  /** Fetch All Branches */
  fetchAllBranch: "/riders/dashboard/branches",

  /** fetchSingleBranch */
  fetchSingleBranch: "/riders/dashboard/branches/detail",

  /** fetchUserCountryMobileCode */
  fetchUserCountryMobileCode: "/core/city-states/locations",

  /** createUser */
  createUser: "/auth/dashboard/riders/users-register",

  /** FetchAllUser */
  fetchAllUser: "/auth/dashboard/riders/users-filter",

  /**Fetch MotorCycle */
  fetchMotorCylce: "/riders/motorcycle",

  /**Fetch Varient */
  fetchVarient: "",

  /** Vechicle On boarding */
  vechicleOnBoard: "/riders/dashboard/vehicles/onboarding",

  /**Pending vehicle on boarding */
  pendingVechicleOnBoard: "/riders/dashboard/vehicles/member-motocycle",

  /** Vechile detail */
  vechicleDetail: "/riders/dashboard/vehicles/detail",

  /** ridersRegister */
  ridersRegister: "/riders/dashboard/register",

  /**fetchSingleUser */
  fetchSingleUser: "/auth/dashboard/riders/users-detail",

  /** deleteBranch */
  deleteBranch: "/riders/dashboard/branches",

  /** fetchAllRidesMembership */
  fetchAllRidesMembership: "/riders/dashboard/riders",

  /**fetchSingleRideMembership */
  fetchSingleRideMembership: "/riders/dashboard/riders/detail",

  /** approveRideMembership */
  approveRideMembership: "/riders/dashboard/riders",

  /** createTestimonial */
  createTestimonial: "/riders/dashboard/branches/testimonials",

  /**registerUserConsentForm */

  registerUserConsentForm: "/user/dashboard/consent",

  /** Get User Permissions */
  getUserPermissions: "user/dashboard/permissions",

  /** Get Current User Profile */
  getUserProfile: "/auth/dashboard/profile",

  /*** validate JWT Token   */
  checkJWT: "/auth/dashboard/verify-token",

  /** fetchConsentForm   */
  fetchConsentForm: "/user/dashboard/consent",

  /** fetchRideCountry */
  fetchRideCountry: "/riders/dashboard/attendee/review-countries",

  /** fetchAllRide */
  fetchAllRide: "/riders/dashboard/branches/rides",

  /** fetchAllReview */
  fetchAllReview: "/riders/dashboard/attendee/review",

  /**fetchSingleRide */
  fetchSingleRide: "/riders/dashboard/branches/rides-detail",

  /**createRide */
  createRide: "/riders/dashboard/branches/rides",

  /** updateRide */
  updateRide: "/riders/dashboard/branches/rides",

  /** updateVinOfUser */
  updateVinOfUser: "/riders/dashboard/vehicles/onboarding",

  /** Moderation Status */
  moderationStatus: "/riders/dashboard/branches/moderation",

  /** fetchDealerProfileForApplyBranch */

  fetchDealerProfileForApplyBranch: "/riders/dashboard/dealer/profile",

  /** fetchOnBoardedUsers */

  fetchOnBoardedUsers: "/riders/dashboard/user-listing",

  /* EVent State */

  fetchEventState: "/core/city-states/locations",

  /* EVent City */

  fetchEventCity: "/core/city-states/locations",

  /* EVent */

  createEvent: "/riders/dashboard/branches/events",

  /* EVent Detail */

  fetchSingleEvent: "/riders/dashboard/branches/events-detail",

  /**EVent For Moderation */

  fetchEventForModeration: "/riders/dashboard/branches/event-moderation",

  /**EVent For Moderation */

  moderateEvent: "/riders/dashboard/branches/event-moderation",

  /**Event Gallery */
  moderateEventGallery: "/riders/dashboard/branches/activity-gallery",

  /**Ride For Moderation */

  fetchRidesForModeration: "/riders/dashboard/branches/ride-moderation",

  /**Ride For Moderation */

  fetchReviewForModeration: "/riders/dashboard/attendee/review",

  fetchReviewCountry: "/riders/dashboard/attendee/review-countries",

  fetchBranch: "/riders/dashboard/attendee/review-branches",

  fetchReviewFilter: "/riders/dashboard/attendee/review-filter",

  /**Ride For Moderation */

  moderateRides: "/riders/dashboard/branches/ride-moderation",

  /**User Moderate Ride */

  fetchUserForJoinRide: "/riders/dashboard/attendee/moderation",

  /**User to join Ride */

  joinNewUser: "/riders/dashboard/attendee/join-ride",

  /** Pre Register User */

  fetchPreRegisteredUser: "/riders/dashboard/pre-registration",

  /** Export to Excel Pre Reg*/

  exportToExcelPreReg:
    "/node/utility/dashboard/riders/pre-registrations-download",

  /** Export to Excel on Board*/

  exportToExcelOnBoard: "/node/utility/dashboard/riders/users-listing-download",

  /** Export to Excel Club Member*/

  exportToExcelClubMember:
    "/node/utility/dashboard/riders/club-members-download",

  /** Image For Moderation */

  fetchImagesForModeration: "/riders/dashboard/attendee/gallery-filter",

  fetchCountryForImageModeration:
    "/riders/dashboard/attendee/gallery-countries",

  fetchBranchForImageModeration: "/riders/dashboard/attendee/gallery-branches",

  /** Image For Moderation */

  moderateRideImages: "/riders/dashboard/attendee/gallery",

  /** Update Ride By Admin */

  updateRideByAdmin: "/riders/dashboard/branches/rides",

  /** Update Event By Admin */

  updateEventByAdmin: "/riders/dashboard/branches/events",

  /** Fetch Filter for Images */

  fetchFilterForImageModeration: "/riders/dashboard/attendee/gallery-filter",

  /** Fetch User Vehicles */

  fetchUserVehicles: "riders/dashboard/riders/users-vehicles",

  getActivityForReview: "riders/dashboard/attendee/review-activities",

  getActivityForGallery: "riders/dashboard/attendee/gallery-activities",

  /** Fetch Vin Lookup */

  fetchVinLookup: "/riders/dashboard/vehicles/vin-detail",

  /** Ownership Transfer */

  ownershipTransfer: "/riders/dashboard/vehicles/transfer-ownership",

  /** Fetch Members Reports */

  fetchMembersReports: "/riders/dashboard/reports/rce-member-listing",

  /** Excel export Members reports */

  exportToExcelMembersReports:
    "/node/utility/dashboard/riders/member-reports-download",

  /**Fetch Non Members Reports */

  fetchNonMembersReports: "/riders/dashboard/reports/non-member-listing",

  /**Excel export non memebers reports */

  exportToExcelNonMembersReports:
    "/node/utility/dashboard/riders/non-member-reports-download",

  analytics: "/riders/dashboard/stats",

  fetchTransferModerationListing:
    "/riders/dashboard/vehicles/transfer-moderation-listing",

  transferModeration: "/riders/dashboard/vehicles/transfer-moderation",

  fetchRidesReports: "/riders/dashboard/reports/rides-listing",

  fetchEventsReports: "/riders/dashboard/reports/events-listing",

  fetchBranchReports: "/riders/dashboard/reports/branch-listing",

  exportToExcelRidesReports:
    "/node/utility/dashboard/riders/rides-report-download",

  exportToExcelEventsReports:
    "/node/utility/dashboard/riders/events-report-download",

  exportToExcelBranchReports:
    "/node/utility/dashboard/riders/branch-report-download",

  exportToExcelForReview:
    "/node/utility/dashboard/riders/riders-reviews-download",

  customerAnalytics: "/riders/dashboard/stats/customer-count",

  eventsAnalytics: "/riders/dashboard/stats/events-count",

  ridesAnalytics: "/riders/dashboard/stats/rides-count",

  uploadUrl: "/node/utility/storage/",

  readUrl: "/node/utility/storage/",

  vehicleTransferDetails: "/riders/dashboard/vehicles/vehicle-transfer-details",

  fetchPartnersList: "/riders/dashboard/partner/moderation",

  fetchPartnersDeatils: "riders/dashboard/partner",

  fetchToursList: "/riders/dashboard/wanderlust/moderation",

  fetchToursDetail: "/riders/dashboard/wanderlust",

  fetchTestimonialList: "/riders/dashboard/testimonials/moderation",

  fetchTestimonialDeatils: "/riders/dashboard/testimonials",

  createTours: "/riders/dashboard/wanderlust",

  partnerForm: "/riders/dashboard/partner",

  updatePartner: "/riders/dashboard/partner/partner-update",

  updateModeration: "/riders/dashboard/wanderlust/update",

  updateTestimonials: "/riders/dashboard/testimonials",

  createTestimonials: "/riders/dashboard/testimonials",

  deleteTour: "/riders/dashboard/wanderlust",

  updateTour: "/riders/dashboard/wanderlust",

  testimonialGalleryApprove: "/riders/dashboard/testimonials/gallery",

  partnerAnalytics: "/riders/dashboard/stats/partner-count",

  updateTestimonialsDeatils: "/riders/dashboard/testimonials/update",

  galleryModeration : '/riders/dashboard/gallery/moderation',

  rankingApi: '/riders/ranking?rankingType=region',
};
